import React from "react";
import { Checkbox } from "antd";
import { Controller } from "react-hook-form";
import "./ChantCheckbox.css";

const ChantCheckbox = ({
  label,
  helpText,
  control,
  name,
  rules,
  checked,
  defaultChecked,
  disabled,
  indeterminate,
  onChange: customOnChange,
  children,
  className,
  style,
  type = "primary",
  ...props
}) => {
  const handleChange = (e) => {
    if (customOnChange) {
      customOnChange(e);
    }
  };

  const checkboxClassName = `chant-checkbox ${type === "secondary" ? "chant-checkbox-secondary" : ""} ${className || ""}`;

  // If control and name are provided, use Controller pattern
  if (control && name) {
    return (
      <div className="chant-checkbox-container">
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field, fieldState: { error } }) => (
            <div>
              <div className="chant-checkbox-wrapper">
                <Checkbox
                  {...field}
                  checked={field.value}
                  defaultChecked={defaultChecked}
                  disabled={disabled}
                  indeterminate={indeterminate}
                  className={checkboxClassName}
                  style={style}
                  onChange={(e) => {
                    // Call React Hook Form's onChange first
                    field.onChange(e);
                    // Then call custom onChange if provided
                    if (customOnChange) {
                      customOnChange(e);
                    }
                  }}
                  {...props}
                >
                  {label || children}
                </Checkbox>
              </div>
              {helpText && (
                <div className="chant-checkbox-help">{helpText}</div>
              )}
              {error && (
                <div className="chant-checkbox-error">{error.message}</div>
              )}
            </div>
          )}
        />
      </div>
    );
  }

  // Otherwise, use the original pattern for backward compatibility
  return (
    <div className="chant-checkbox-container">
      <div className="chant-checkbox-wrapper">
        <Checkbox
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
          indeterminate={indeterminate}
          onChange={handleChange}
          className={checkboxClassName}
          style={style}
          {...props}
        >
          {label || children}
        </Checkbox>
      </div>
      {helpText && <div className="chant-checkbox-help">{helpText}</div>}
    </div>
  );
};

export default ChantCheckbox;
